import React from 'react';
import { log } from './utils/logger';

// 立即加载生产环境日志抑制器（必须在所有其他代码之前）
import './utils/productionLogSuppressor';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useRoutePreloader, useHoverPreloader } from './hooks/useRoutePreloader';

// 导入页面组件
import HomePage from './pages/HomePage';
import PricingPage from './pages/PricingPage';
import FeaturesPage from './pages/FeaturesPage';
import DownloadPage from './pages/DownloadPage';
import UserAgreementPage from './pages/UserAgreementPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import RefundPolicyPage from './pages/RefundPolicyPage';

// 导入布局组件
import Layout from './components/Layout';

// 初始化 Google Analytics
import('./services/analyticsService').then(({ analytics }) => {
  analytics.initialize().catch(error => {
    log.warn('Google Analytics 初始化失败', error);
  });
});

// 立即预加载 Paddle SDK（网站打开时就开始加载，实现零感知）
import('./services/paddlePreloader').then(({ preloadPaddle }) => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      preloadPaddle().catch(error => {
        log.warn('Paddle SDK 预加载失败', error);
      });
    }, { timeout: 2000 });
  } else {
    setTimeout(() => {
      preloadPaddle().catch(error => {
        log.warn('Paddle SDK 预加载失败', error);
      });
    }, 100);
  }
});

const App: React.FC = () => {
  // 智能预加载
  useRoutePreloader();
  useHoverPreloader();

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/features" element={<FeaturesPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/download" element={<DownloadPage />} />
        <Route path="/user-agreement" element={<UserAgreementPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/refund-policy" element={<RefundPolicyPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
};

export default App; 